import { AlphaYCircleOutlineIcon } from './AlphaYCircleOutlineIcon';

/**
 * author: Contributors
 * id 94DF1C7C-7FDE-4AD8-B6F9-B23C3C4DA478
 * name alpha-y-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-y-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetYCircleOutlineIcon = AlphaYCircleOutlineIcon;
export default AlphabetYCircleOutlineIcon